import { getByPathAndParams, postByPathAndData } from './newServices';

import { TEMPLATES_PATHS } from '@common/network/ApiPaths';

const fetchTemplateOneSourceApi = async (sourceId) => {
  const { data } = await getByPathAndParams({
    path: TEMPLATES_PATHS.ONE_SOURCE,
    pathVariables: { sourceId },
  });

  const parsedStructure = JSON.parse(data?.structure);

  return parsedStructure;
};

const fetchTemplateDetailsApi = async (id) => {
  const { data } = await getByPathAndParams({
    path: TEMPLATES_PATHS.GET_BY_ID,
    pathVariables: { id },
  });

  return data;
};

const fetchTemplateCustomEmailApi = async () => {
  const { data } = await postByPathAndData({
    path: TEMPLATES_PATHS.GET_CUSTOM_EMAIL_DATA,
  });

  return data;
};

export {
  fetchTemplateOneSourceApi,
  fetchTemplateDetailsApi,
  fetchTemplateCustomEmailApi,
};
